export class OccupationTiss {
    id: number;
    tissId: number;
    occupationId: number;
    code: number;
}